import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import PeoplePage from "./PeoplePage";
import MyEvaluationPage from "./MyEvaluationPage";
import MyLicencePage from "./MyLicencePage";
import DatesPage from "./DatesPage";
import ProgressPage from "./ProgressPage";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { setCurrentTab } from "../../redux/reducers/evaluationDashboard";
import { createTheme, ThemeProvider } from "@mui/material";
import { useLocation, useNavigate } from "react-router";

export default function EvaluationDashboardPage() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tabs: any = useSelector((state: any) => state.evaluationDashboard.tabs);
  const currentTab: any = useSelector(
    (state: any) => state.evaluationDashboard.currentTab
  );

  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    // dispatch(setCurrentTab(newValue));
    manageSelectTab(newValue);
  };

  const manageSelectTab = (tabName: string) => {
    switch (tabName) {
      case t("MY_EVALUATION"):
      case "/dashboard/evaluation":
        navigate("/dashboard/evaluation");
        const evalTab:any = t("MY_EVALUATION");
        dispatch(setCurrentTab(evalTab));
        break;
      case t("MY_LICENCE"):
      case "/dashboard/licence":
        navigate("/dashboard/licence");
        const licenceTab:any = t("MY_LICENCE");
        dispatch(setCurrentTab(licenceTab));
        break;
      case t("PEOPLE"):
      case "/dashboard/people":
        navigate("/dashboard/people");
        const peopleTab:any = t("PEOPLE");
        dispatch(setCurrentTab(peopleTab));
        break;
      case t("DATES"):
      case "/dashboard/dates":
        navigate("/dashboard/dates");
        const datesTab:any = t("DATES");
        dispatch(setCurrentTab(datesTab));
        break;
      case "PROGRESS":
      case "/dashboard/progress":
        navigate("/dashboard/progress");
        const progressTab:any = "PROGRESS";
        dispatch(setCurrentTab(progressTab));
        break;
    }
  }

  useEffect(() => {
    manageSelectTab(location.pathname);
  }, [location]);

  const theme = createTheme({
    components: {},
  });
  return (
    <ThemeProvider theme={theme}>
      <Box className={"contentSpacing"}>
        <TabContext value={currentTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              sx={{
                ".MuiTabs-indicator": {
                  width: "0px !important",
                },
              }}
            >
              {tabs &&
                tabs?.map((item: string, index: number) => (
                  <Tab
                    sx={
                      item === currentTab
                        ? { borderBottom: "2px solid #1976d2" }
                        : { borderBottom: "2px solid rgba(255, 255, 255, 0)" }
                    }
                    key={index}
                    label={t(item.toUpperCase())}
                    value={item}
                  />
                ))}
            </TabList>
          </Box>
          <TabPanel value={t("MY_EVALUATION")}>
            <MyEvaluationPage />
          </TabPanel>
          <TabPanel value={t("MY_LICENCE")}>
            <MyLicencePage />
          </TabPanel>
          <TabPanel value={t("PEOPLE")}>
            <PeoplePage />
          </TabPanel>
          <TabPanel value={t("DATES")}>
            <DatesPage />
          </TabPanel>
          <TabPanel value={"PROGRESS"}>
            <ProgressPage />
          </TabPanel>
        </TabContext>
      </Box>
    </ThemeProvider>
  );
}
